export class DepartmentIdReq{
    departmentId:number
}